module.exports = __webpack_public_path__ + "img/zk-icon-logistics-set.e84158ca.svg";